import dayjs from "dayjs";

export const formatDate = (value: string | null) => (value ? dayjs(value).format('MMM DD HH:mm') : '—');

export function formatRelative(value: string): string {
  const minutes = dayjs().diff(dayjs(value), 'minute');
  if (minutes < 1) return 'just now';
  if (minutes < 60) return `${minutes} min ago`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours} h ago`;
  const days = Math.floor(hours / 24);
  return days === 1 ? '1 day ago' : `${days} days ago`;
}
